<!-- 商品管理 V2 - 搜索筛选面板（字段与 /admin/product/v2/productList 入参一致） -->
<template>
  <div class="search-panel">
    <el-form :model="form" inline size="small">
      <!-- 商品ID或链接（goods_id_or_link，精确） -->
      <el-form-item>
        <el-input v-model="form.goods_id_or_link" clearable :placeholder="$t('message.productName_ProductID_ProductLink')" />
      </el-form-item>
      <!-- 工厂联系人（factory_contact，模糊） -->
      <el-form-item>
        <el-input v-model="form.factory_contact" clearable :placeholder="$t('message.factoryNameFactoryIDFactoryLink')" />
      </el-form-item>
      <!-- 是否绑定辅料（has_material：0/1） -->
      <el-form-item>
        <el-select v-model="form.has_material" clearable :placeholder="$t('message.whetherToBindAuxiliaryMaterials')">
          <el-option v-for="item in yesNoOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <!-- 客户备注（remark，模糊） -->
      <el-form-item>
        <el-input v-model="form.remark" clearable :placeholder="$t('message.productManagementRemarks')" />
      </el-form-item>
      <!-- 是否设置附加服务（has_extra_service：0/1） -->
      <el-form-item>
        <el-select v-model="form.has_extra_service" clearable :placeholder="$t('message.doYouWantToSetOPTION')">
          <el-option v-for="item in yesNoOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <!-- 商品标记名多选（tags[]） -->
      <el-form-item>
        <el-select v-model="form.tags" clearable multiple collapse-tags :placeholder="$t('message.productLabelMultipleChoice')">
          <el-option v-for="item in flagList" :key="item.id" :label="item.name" :value="item.name" />
        </el-select>
      </el-form-item>
      <!-- 维护状态筛选（maintain_status，仅 tab=all：1待维护 2维护中 3待审核 4维护完了） -->
      <el-form-item v-if="activeTab === 'all'">
        <el-select v-model="form.maintain_status" clearable :placeholder="$t('message.identifier')">
          <el-option :label="$t('message.productV2PendingMaintenance')" :value="1" />
          <el-option :label="$t('message.productV2Maintaining')" :value="2" />
          <el-option :label="$t('message.productV2PendingAudit')" :value="3" />
          <el-option :label="$t('message.productV2MaintenanceCompleted')" :value="4" />
        </el-select>
      </el-form-item>
      <!-- 审核类型（audit_type -->
      <el-form-item >
        <el-select v-model="form.audit_type" clearable :placeholder="$t('message.productAuditType')">
          <el-option :label="$t('message.productNormal')" :value="1" />
          <el-option :label="$t('message.productNoNeedToMaintain')" :value="2" />
        </el-select>
      </el-form-item>

      <!-- 客户ID（user_id，integer） -->
      <el-form-item>
        <el-input v-model="form.user_id" clearable :placeholder="$t('message.clientID')" />
      </el-form-item>
      <!-- 客户名称（user_id_or_name，精确） -->
      <el-form-item>
        <el-input v-model="form.user_id_or_name" clearable :placeholder="$t('message.userName')" />
      </el-form-item>
      <!-- 管理番号（client_sku_code，模糊） -->
      <el-form-item>
        <el-input v-model="form.client_sku_code" clearable :placeholder="$t('message.managementDesignation')" />
      </el-form-item>
      <!-- SPU（spu） -->
      <el-form-item>
        <el-input v-model="form.spu" clearable placeholder="SPU" />
      </el-form-item>
      <!-- 产品类型（supply_type，精确） -->
      <el-form-item>
        <el-select v-model="form.supply_type" clearable :placeholder="$t('message.productType')">
          <el-option label="现货" value="现货" />
          <el-option label="OEM" value="OEM" />
          <el-option label="ODM" value="ODM" />
        </el-select>
      </el-form-item>
      <!-- 标签号（label_no，模糊） -->
      <el-form-item>
        <el-input v-model="form.label_no" clearable :placeholder="$t('message.labelNo')" />
      </el-form-item>
      <!-- 商品编码（goods_code，模糊） -->
      <el-form-item>
        <el-input v-model="form.goods_code" clearable :placeholder="$t('message.commodityCode')" />
      </el-form-item>
      <!-- 查看方案 ID（view_plan_id） -->
      <el-form-item>
        <el-input v-model="form.view_plan_id" clearable :placeholder="$t('message.productV2ViewPlanId')" />
      </el-form-item>
      <!-- 业务备注（y_remark，模糊） -->
      <el-form-item>
        <el-input v-model="form.y_remark" clearable :placeholder="$t('message.productV2BusinessRemark')" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">{{ $t('message.search') }}</el-button>
        <el-button @click="reset">{{ $t('message.reset') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    // 商品标记下拉（tags 传 name）
    flagList: { type: Array, default: () => [] },
    // 当前 Tab：all / wait / maintaining / pending_audit / done
    activeTab: { type: String, default: 'all' }
  },
  data() {
    return {
      form: this.getDefaultForm(),
      yesNoOptions: [
        { label: this.$t('message.productV2Yes'), value: 1 },
        { label: this.$t('message.productV2No'), value: 0 }
      ]
    }
  },
  watch: {
   
  },
  methods: {
    getDefaultForm() {
      return {
        user_id: this.$route.query.user_id || '',
        goods_id_or_link: '',
        factory_contact: '',
        has_material: '',
        has_extra_service: '',
        y_remark: '',
        remark: '',
        tags: [],
        user_id_or_name: '',
        client_sku_code: this.$route.query.client_sku_code || '',
        spu: '',
        supply_type: '',
        label_no: '',
        goods_code: '',
        view_plan_id: '',
        maintain_status: '',
        audit_type: ''
      }
    },
    // 提交搜索条件（字段名与列表接口一致）
    submit() {
      this.$emit('search', { ...this.form })
    },
    reset() {
      this.form = this.getDefaultForm()
      this.submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-panel {
  min-height: 96px;
  margin-bottom: 20px;

  ::v-deep .el-form {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 16px;
  }

  ::v-deep .el-form-item {
    min-width: 0;
    margin: 0;
  }

  ::v-deep .el-form-item__content,
  ::v-deep .el-input,
  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-input__inner {
    height: 40px;
    border-color: #dcdfe6;
    border-radius: 4px;
  }

  ::v-deep .el-button {
    width: 68px;
    height: 40px;
    margin: 0 12px 0 0;
    padding: 0;
  }

  ::v-deep .el-button--primary {
    border-color: #b4272d;
    background: #b4272d;
  }
}
</style>
